import React from 'react'
import ReactPaginate from 'react-paginate'
import PropTypes from 'prop-types'
import cn from 'classnames'

import './styles.scss'

const bc = 'pagination'

const Pagination = ({ pageCount, onPageChange, initialPage, pageRangeDisplayed = 3 }) => {
  return pageCount > 1 ? (
    <ReactPaginate
      pageCount={pageCount}
      pageRangeDisplayed={pageRangeDisplayed}
      marginPagesDisplayed={0}
      previousLabel=""
      nextLabel=""
      containerClassName={`${bc}__list`}
      pageClassName={`${bc}__item`}
      pageLinkClassName={`${bc}__link`}
      activeClassName={`${bc}__item--active`}
      previousClassName={`${bc}__item`}
      nextClassName={`${bc}__item`}
      previousLinkClassName={cn(`${bc}__link`, `${bc}__link--prev`)}
      nextLinkClassName={cn(`${bc}__link`, `${bc}__link--next`)}
      onPageChange={onPageChange}
      breakClassName={`${bc}__break`}
      initialPage={initialPage || 0}
      forcePage={initialPage}
    />
  ) : null
}

Pagination.propTypes = {
  pageCount: PropTypes.number.isRequired,
  initialPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageRangeDisplayed: PropTypes.number,
}

Pagination.displayName = 'Pagination'

export default Pagination
